import { getIsCypressOnLocalhost } from '@sureapp/platform-sdk';
import { normalizeGoogleAddress } from '@sureapp/wl-toggle-common/dist/utils/utils';
import isString from 'lodash/isString';
import split from 'lodash/split';
import { geocodeByAddress } from 'react-places-autocomplete';

export function getGeocodedNormalizedAddress(addressObj, opts = {}) {
  const optsWithDefaults = {
    withLatLng: false,
    ...opts,
  };

  if (getIsCypressOnLocalhost()) {
    if (isString(addressObj)) {
      const addressList = split(addressObj, ',');
      return Promise.resolve({
        line1: addressList[0],
        city: addressList[1].trim(),
        region: {
          name: addressList[2].trim(),
          code: addressList[2].trim(),
        },
        postal: addressList.length > 2 ? addressList[3].trim() : undefined,
      });
    }
    return Promise.resolve({
      ...addressObj,
      region: isString(addressObj.region)
        ? {
            name: addressObj.region,
            code: addressObj.region,
          }
        : addressObj.region,
    });
  }

  const addressStr = isString(addressObj)
    ? addressObj
    : [
        addressObj.line1,
        addressObj.city,
        addressObj.region,
        addressObj.postal,
      ].join(' ');

  return geocodeByAddress(addressStr).then((geocodedAddress) => {
    if (optsWithDefaults.withLatLng) {
      const { location } = geocodedAddress[0].geometry;
      return {
        ...normalizeGoogleAddress(geocodedAddress[0], opts.isAlpha2),
        latitude: Number(location.lat().toFixed(12)),
        longitude: Number(location.lng().toFixed(12)),
      };
    }
    return normalizeGoogleAddress(geocodedAddress[0]);
  });
}
